import { Buttons } from './ShopDown.styles';
import ShopDownButton from './ShopDownButton';
import {
  Heading,
  HeadingDescription,
  HeadingTitle,
  ShopTermsCard
} from '../ShopTerms.styles';

const ShopDown = () => {
  return (
    <ShopTermsCard>
      <Heading>
        <HeadingTitle>Shop by cash down</HeadingTitle>
        <HeadingDescription>
          The more you pay upfront, the more vehicles to choose from.
        </HeadingDescription>
      </Heading>
      <Buttons>
        <ShopDownButton key={0} index={0} />
        <ShopDownButton key={1} index={1} />
        <ShopDownButton key={2} index={2} />
      </Buttons>
    </ShopTermsCard>
  );
};

export default ShopDown;
